module.exports = __webpack_public_path__ + "media/img/circle-arrow-left-solid-ab0b277713b82e66af514573a58d48f6.svg";